import './WorldBlock.scss'

import {
	ProjectType,
	ProjectsOverview
} from '../layout/worldmap/ProjectsOverview'
import {RegionSelector, RegionType} from '../layout/worldmap/RegionSelector'
import {ThemeType, Themes} from '../layout/worldmap/Themes'
import {useHistory, useLocation} from 'react-router'

import {Block} from './Blocks'
import {MarkedTitle} from '../ui/MarkedTitle'
import React from 'react'
import {Worldmap} from '../layout/worldmap/Worldmap'
import qs from 'query-string'
import {style} from 'util/style'

const styles = style('worldblock', ['themes', 'map', 'partners'])
const CONTINENT_URL_PARAM = 'continent'
const THEME_URL_PARAM = 'theme'
const REGION_URL_PARAM = 'region'
const queryStringOptions = {arrayFormat: 'bracket'}
export type WorldBlockType = {
	title: string
	themes: Array<ThemeType>
	regions: Array<RegionType>
	projects: Array<ProjectType>
}

export const WorldBlock: React.FC<WorldBlockType & {container?: boolean}> = ({
	container,
	title,
	themes,
	regions,
	projects
}) => {
	const location = useLocation()
	const history = useHistory()
	const search = location.search
	const parsed = qs.parse(search, queryStringOptions)
	const selectedThemes = parsed[THEME_URL_PARAM]
	const selectedContinent = parsed[CONTINENT_URL_PARAM]
	const selectedRegion = parsed[REGION_URL_PARAM]

	const writeToUrl = (parsedValue) => {
		const stringifiedSearch = qs.stringify(parsedValue, queryStringOptions)
		location.search = stringifiedSearch
		history.replace(location)
	}

	const toggleSearchparamByKey = (key: string, value: string) => {
		const searchParam = parsed[key] || []
		const valuePosition = searchParam.indexOf(value)
		const inArray = valuePosition > -1
		inArray ? searchParam.splice(valuePosition, 1) : searchParam.push(value)
		parsed[key] = searchParam
		writeToUrl(parsed)
	}

	const replaceSearchParamsByValue = (
		key: string,
		value: Array<string> | string
	) => {
		parsed[key] = value
		writeToUrl(parsed)
	}

	return (
		<Block container={container} className={styles().mod({title})}>
			{title && (
				<div className={styles('markedtitle')}>
					<MarkedTitle title={title} as="h2" />
				</div>
			)}
			<div className={styles('content')}>
				<div className={styles('content-themes')}>
					<Themes
						themes={themes}
						highlightedThemes={selectedThemes}
						onThemeSelect={(theme) =>
							toggleSearchparamByKey(THEME_URL_PARAM, theme)
						}
						onAllThemesSelect={(allThemes) =>
							replaceSearchParamsByValue(THEME_URL_PARAM, allThemes)
						}
						onThemeClear={() => replaceSearchParamsByValue(THEME_URL_PARAM, [])}
					/>
				</div>
				<div className={styles('content-map')}>
					<Worldmap
						highlightedContinent={selectedContinent}
						onContinentSelect={(continent) => {
							replaceSearchParamsByValue(CONTINENT_URL_PARAM, continent)
							replaceSearchParamsByValue(REGION_URL_PARAM, null)
						}}
					/>
					<div className={styles('content-map-regions')}>
						<RegionSelector
							regions={regions}
							onRegionSelect={(continent, region) => {
								replaceSearchParamsByValue(CONTINENT_URL_PARAM, continent)
								replaceSearchParamsByValue(REGION_URL_PARAM, region)
							}}
							highlightedContinent={selectedContinent}
							highlightedRegion={selectedRegion}
						/>
					</div>
				</div>
			</div>
			<ProjectsOverview
				continent={selectedContinent}
				region={selectedRegion}
				themes={selectedThemes}
				projects={projects}
			/>
		</Block>
	)
}
